import {DTO} from '@/shared/base/dto';
import {ENDPOINT, METHOD} from '@/constants';

class BasePasswordDTO extends DTO {
  public url!: string;
  public method = METHOD.POST;
  public query: undefined;
  public param: undefined;

  constructor(
    public body: {
      oldPassword?: string;
      newPassword?: string;
      confirmNewPassword?: string;
      email?: string;
    },
  ) {
    super();
  }
}

export class ForgotPassBody {
  public email!: string;
}

export class ForgotPassResponse {
  public status!: string;
  public message!: string;
}

export class ForgotPassDTO extends BasePasswordDTO {
  public static url = ENDPOINT.FORGOT_PASSWORD;
  public url = ForgotPassDTO.url;

  constructor(public body: ForgotPassBody) {
    super(body);
  }
}

export class ChangePasswordBody {
  public oldPassword!: string;
  public newPassword!: string;
  public confirmNewPassword!: string;
}

export class ChangePasswordResponse {
  public status!: string;
  public message!: string;
}

export class ChangePasswordDTO extends BasePasswordDTO {
  public static url = ENDPOINT.CHANGE_PASS;
  public url = ChangePasswordDTO.url;

  constructor(public body: ChangePasswordBody) {
    super(body);
  }
}
